const TEST_IDS = {
  valueInput: 'value-input',
  submitButton: 'submit-button',
  receiveNativeToken: 'withdraw-modal-receive-native-token',
  availableAmount: 'available-amount',
};

export default TEST_IDS;
